import { Button, CloseIcon, Drawer, Text } from '@mercai/clever'
import { useTranslation } from 'react-i18next'

import {
  DrawerFilterCatalogProductCard,
  DrawerFilterDeliveryOptionCard,
  DrawerFilterRootCategoryCard,
  DrawerFilterSupplierCard,
} from './components'

import styles from './drawer-filter.module.css'

import { DrawerFilterProps } from './drawer-filter.type'

export const GeneratePurchaseOrderDrawerFilter = ({
  isOpen,
  onHandleOpen,
  filter,
  onHandleFilter,
}: DrawerFilterProps) => {
  const { t } = useTranslation('screenInventoryList')

  const commonProps = {
    filter,
    onChangeFilter: onHandleFilter,
  }

  return (
    <Drawer isOpen={isOpen} onHandleOpen={onHandleOpen}>
      <div className={styles.header}>
        <Text variant="title-large" className={styles['header-title']}>
          {t('filterTitle')}
        </Text>

        <button
          className={styles['header-button']}
          type="button"
          onClick={onHandleOpen}
        >
          <CloseIcon />
        </button>
      </div>

      <div className={styles.content}>
        <DrawerFilterCatalogProductCard
          key="catalogProductUuid"
          {...commonProps}
        />

        <DrawerFilterSupplierCard key="supplierUuid" {...commonProps} />

        <DrawerFilterRootCategoryCard key="rootCategory" {...commonProps} />

        <DrawerFilterDeliveryOptionCard key="deliveryOption" {...commonProps} />
      </div>

      <div className={styles.footer}>
        <Button variant="secondary" onClick={onHandleOpen}>
          {t('filterBack')}
        </Button>
      </div>
    </Drawer>
  )
}
